import { ApiServiceV2 } from 'services';
import {
	getMyEntityActiveUsers,
	getSpecificUsers,
	getMyEntityWarehouses,
} from 'utils/libs';

export const getLegacyReportFilterOptions = async (
	param,
	{ moduleItemId, profile }
) => {
	let rows;
	switch (param) {
		case 'projectsParam':
			rows = await ApiServiceV2.get({
				url: `/departments/v1/projects/${moduleItemId ?? 'null'}`,
			});
			return (Array.isArray(rows) ? rows : []).map(row => ({
				id: row.id,
				name: row.name,
			}));
		case 'entityParam':
			rows = await ApiServiceV2.get({ url: '/users/getOrganizationUsers' });
			return getSpecificUsers(
				getMyEntityActiveUsers(Array.isArray(rows) ? rows : [], profile),
				{ entities: true }
			).map(row => ({ id: row.id, name: row.name }));
		case 'warehouseParam':
			rows = await ApiServiceV2.get({ url: '/warehouses' });
			return getMyEntityWarehouses(
				Array.isArray(rows) ? rows : [],
				profile
			).map(row => ({ id: row.id, name: row.name }));
		case 'itemParam':
			rows = await ApiServiceV2.get({ url: '/items' });
			return (Array.isArray(rows) ? rows : []).map(row => ({
				id: row.item_id ?? row.id,
				name: `<${row.item}> ${row.shortName ?? row.short_name ?? row.name}`,
			}));
		default:
			return [];
	}
};
